<div>
  <div>{{ readyMsg1! }}</div>
  <div *ngIf="readyMsg2">{{ readyMsg2! }}</div>
</div>
